import c from "axios";
import * as a from "@sentry/react";
const y = (p) => {
  const e = c.create({
    baseURL: "https://staging.minohealth.ai:3000",
    headers: {
      Authorization: `Bearer ${p}`,
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  }), n = c.create({
    baseURL: "https://staging.minohealth.ai:3000",
    headers: {
      Authorization: `Bearer ${p}`,
      Accept: "application/json",
      "Content-Type": "multipart/form-data"
    }
  });
  function i(t) {
    return (s) => (s.params ||= {}, Object.assign(s.params, t), s);
  }
  function m(t) {
    let s = t?.response?.request?.responseURL;
    return t?.response?.request?.status === 401 && !l(s) && document.dispatchEvent(new CustomEvent(h, {})), Promise.reject(t);
  }
  const d = ["/signin", "/google", "/linkedin"];
  function l(t) {
    for (let s of d)
      if (t.endsWith(s)) return !0;
    return !1;
  }
  return e.interceptors.response.use((t) => t, m), n.interceptors.response.use((t) => t, m), e.interceptors.request.use(i({ lng: u })), n.interceptors.request.use(i({ lng: u })), e.interceptors.request.use(
    (t) => (a.addBreadcrumb({
      category: "http",
      type: "http",
      level: "info",
      message: `${t.method?.toUpperCase()} ${t.url}`,
      data: {
        url: t.url,
        method: t.method,
        baseURL: t.baseURL,
        params: t.params,
        headers: {
          "Content-Type": t.headers["Content-Type"],
          Authorization: t.headers.Authorization ? "Bearer [REDACTED]" : void 0
        }
      }
    }), t),
    (t) => (a.addBreadcrumb({
      category: "http",
      type: "error",
      level: "error",
      message: "Request setup failed",
      data: { error: t.message }
    }), Promise.reject(t))
  ), n.interceptors.request.use(
    (t) => (a.addBreadcrumb({
      category: "http",
      type: "http",
      level: "info",
      message: `${t.method?.toUpperCase()} ${t.url} (multipart)`,
      data: {
        url: t.url,
        method: t.method,
        baseURL: t.baseURL,
        params: t.params
      }
    }), t)
  ), e.interceptors.response.use(
    (t) => (a.addBreadcrumb({
      category: "http",
      type: "http",
      level: "info",
      message: `${t.config.method?.toUpperCase()} ${t.config.url} - ${t.status}`,
      data: {
        url: t.config.url,
        method: t.config.method,
        status: t.status,
        statusText: t.statusText,
        responseTime: t.headers["x-response-time"]
      }
    }), t),
    (t) => {
      const s = t.response?.status, o = t.config?.url, r = t.config?.method;
      return a.addBreadcrumb({
        category: "http",
        type: "error",
        level: "error",
        message: `${r?.toUpperCase()} ${o} - ${s || "Network Error"}`,
        data: {
          url: o,
          method: r,
          status: s,
          statusText: t.response?.statusText,
          errorMessage: t.message,
          responseData: t.response?.data
        }
      }), a.captureException(t, {
        tags: {
          api_endpoint: o,
          http_method: r,
          http_status: s
        },
        contexts: {
          response: {
            status: s,
            statusText: t.response?.statusText,
            data: t.response?.data
          },
          request: {
            url: o,
            method: r,
            params: t.config?.params
          }
        }
      }), Promise.reject(t);
    }
  ), n.interceptors.response.use(
    (t) => (a.addBreadcrumb({
      category: "http",
      type: "http",
      level: "info",
      message: `${t.config.method?.toUpperCase()} ${t.config.url} (multipart) - ${t.status}`,
      data: {
        url: t.config.url,
        method: t.config.method,
        status: t.status
      }
    }), t),
    (t) => {
      const s = t.response?.status, o = t.config?.url, r = t.config?.method;
      return a.addBreadcrumb({
        category: "http",
        type: "error",
        level: "error",
        message: `${r?.toUpperCase()} ${o} (multipart) - ${s || "Network Error"}`,
        data: {
          url: o,
          method: r,
          status: s,
          errorMessage: t.message
        }
      }), a.captureException(t, {
        tags: {
          api_endpoint: o,
          http_method: r,
          http_status: s,
          content_type: "multipart/form-data"
        }
      }), Promise.reject(t);
    }
  ), {
    PostLogin: (t) => e.post("/signin", t),
    PostAiTest: (t, s) => n.post("/aitest", t, s),
    PostUser: (t) => e.post("/user", t),
    PatchUser: (t) => e.patch("/user", t),
    SearchUser: (t) => e.get("/search", { params: t }),
    GetUser: (t) => e.get("/user", { params: t }),
    PostPatients: (t) => e.post("/patient", t),
    GetPatient: (t) => e.get("/patient", { params: t }),
    GetHistory: (t) => e.get("/history", { params: t }),
    PatchHistory: (t) => e.patch("/history", t),
    PostPayment: (t) => e.post("/payment", t),
    GetPayment: (t) => e.get("/payment", { params: t }),
    PostFreeCheckout: (t) => e.post("/payment/free", t),
    GetPlan: (t) => e.get("/plan", { params: t }),
    PostLinkedin: (t) => e.post("/linkedin", t),
    PostGoogle: (t) => e.post("/google", t),
    GetAnalytics: (t) => e.get("/analytics", { params: t }),
    PatchEvaluationRankings: (t) => e.patch("/evaluation", t),
    ReadEvaluation: (t) => e.get("/evaluation", { params: t }),
    GetAccounts: (t) => e.get("/accounts", { params: t }),
    GetMembershipInvite: (t) => e.get("/membership-invite", { params: t }),
    GetReviewers: (t, s) => e.get("/reviewers", { params: t, ...s }),
    GetPromos: (t, s) => e.get("/promo", { params: t, ...s }),
    PostPromo: (t) => e.post("/promo", t),
    PatchPromo: (t) => e.patch("/promo", t),
    ValidatePromo: (t) => e.post("/promo/validate", t),
    GetTools: (t) => e.get("/tools", t),
    PostTool: (t) => e.post("/tools", t),
    PatchTool: (t) => e.patch("/tools", t),
    DeleteTool: (t) => e.delete("/tools", { params: { id: t } })
  };
};
let u;
function P(p) {
  u = p;
}
const h = "message:timeout";
export {
  h as SESSION_TIMEOUT_EVENT,
  y as default,
  P as setApiLanguage
};
